module.exports = __webpack_public_path__ + "16eed93db9a2ca5828e5932ff1bf08ff.svg";